<template>
  <div>
    <div v-if="loading">
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </div>

    <div v-else>
      <div class="container-fluid title-page">
        <v-row>
          <v-col cols="12" sm="12">
            <h2>{{ quiz.title }}</h2>
          </v-col>
        </v-row>
      </div>

      <v-main fluid class="quiz-page" style="padding: 0 !important">
        <v-progress-circular
          :rotate="360"
          :size="130"
          :width="15"
          :value="timerPercentage"
          color="teal"
        >
          <p>{{ minutesToAnswer }}</p>
          <span>minutos</span>
        </v-progress-circular>


        <div class="container-fluid">
          <v-col cols="12" md="12" class="pl-0 pr-0">

            <v-stepper v-model="step">
              <v-stepper-header>
                <template v-for="(question, $index) in quiz.questions">
                  <v-stepper-step
                    :key="`${$index}-step`"
                    :complete="step > ($index + 1)"
                    :step="($index + 1)"

                  >
                    <!-- {{ ($index + 1) }}ª Pergunta -->
                  </v-stepper-step>

                  <v-divider
                    :key="`${$index}-div`"
                    v-if="($index + 1) < quiz.questions.length"
                  ></v-divider>
                </template>

              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content
                  v-for="(question, $index) in quiz.questions"
                  :key="`${$index}-content`"
                  :step="($index + 1)"
                >

                  <v-card class="my-2 mx-2" v-if="currentQuestion">
                    <v-card-text class="px-4 py-4 title-ask" v-html="question.ask"></v-card-text>
                    <v-card-text class="pl-3">
                      <span v-for="(answer, $indexAnswer) in question.answers" :key="$indexAnswer">
                        <v-checkbox v-model="responses" :label="answer.text"
                                    :value="question._id + '_' + answer._id"></v-checkbox>
                      </span>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="green" v-if="step > 1" @click="prevQuestion" :disabled="sending" dark
                             class="mt-3 ml-0">
                        Anterior
                      </v-btn>

                      <v-divider></v-divider>
                      <v-btn color="green" @click="nextQuestion" :disabled="sending" dark class="mt-3 ml-0">
                        {{ btnNextTxt }}
                      </v-btn>
                    </v-card-actions>

                  </v-card>

                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-col>
        </div>

        <!-- <v-col cols="12" md="2" class="text-center">
          <v-progress-circular
            :rotate="360"
            :size="180"
            :width="40"
            :value="timerPercentage"
            color="purple"
          >
            {{ minutesToAnswer }}'
          </v-progress-circular>
        </v-col> -->


      </v-main>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { swalConfirm } from '@/helpers'

export default {
  name: 'Quiz',
  data () {
    return {
      interval: {},
      sending: false,
      responseSent: false,
      minutesToAnswer: 30,
      loading: true,
      // btnNextTxt: 'Próxima',
      step: 1,
      responses: [],
      quiz: {},
      percentage: 0,
      courseId: null
    }
  },
  computed: {
    ...mapGetters(['getQuizSessionToken']),
    timerPercentage: function () {
      return (this.minutesToAnswer * 100) / 30
    },
    btnNextTxt: function () {
      return (parseInt(this.step) === this.quiz.questions.length || this.quiz.questions.length === 1) ? 'Finalizar' : 'Próximo'
    },
    currentQuestion: {
      get: function () {
        return this.quiz.questions[(this.step - 1)] || false
      }
    },
    set: function (val) {
      // clearInterval(this.cronAnswer)
    }
  },
  methods: {
    ...mapActions(['deleteContent', 'setQuizSessionToken']),

    getQuiz () {
      const quizId = this.$route.params.quiz_id

      this.axios.get(`/user/quiz/${quizId}`).then(({ data }) => {
        if (data.success) {
          if (!data.quiz) {
            this.$router.push({ name: 'home' })

            return false
          }

          this.quiz = data.quiz
          this.courseId = data.courseId

          if (data.quiz.minutesToExp) {
            this.minutesToAnswer = data.quiz.minutesToExp
          }

          this.setQuizSessionToken(data.quiz.sessionToken)

          this.startCron()
        }
      }).catch(err => {
        console.error(err)

        this.$swal('Ops', 'Houve um erro ao buscar o Quiz', 'error')
      }).finally(() => {
        this.loading = false
      })
    },
    nextQuestion () {
      const stepActive = parseInt(this.step)

      if (stepActive < this.quiz.questions.length) {
        this.step = stepActive + 1

        // this.startCron()
      } else {
        this.sendResponse()
      }
    },
    prevQuestion () {
      const stepActive = parseInt(this.step)

      if (stepActive > 1) {
        this.step = stepActive - 1
      }
    },
    startCron () {
      this.interval = setInterval(() => {
        this.minutesToAnswer--

        if (this.minutesToAnswer <= 0) {
          clearInterval(this.interval)
          this.minutesToAnswer = 0
          this.sendResponse()
          // alert('finalizou')
        }
      }, 60000)
    },
    sendResponse () {
      this.sending = true

      let data = {
        sessionToken: this.getQuizSessionToken,
        responses: this.responses
      }

      if (!this.responseSent) {
        this.axios.post('/user/quiz/response', data).then(response => {
          this.responseSent = true

          this.deleteContent()

          if (this.$route.name === 'quiz-show') {

            this.percentage = response.data.points.percentage || 0

            if (this.percentage < 75) {
              this.$swal('Que pena', 'Você acertou ' + this.percentage.toFixed(2) + '%', 'info').then(() => {
                this.$router.push({ name: 'take-course', params: { course_id: this.courseId } })
              })
            } else {
              this.$swal('Parabéns', 'Você acertou ' + this.percentage.toFixed(2) + '%', 'success').then(() => {
                this.$router.push({ name: 'certificate', params: { course_id: this.courseId } })
              })
            }
          }
        }).catch(err => {
          console.error(err)

          this.$swal('Ops', 'Houve um erro ao enviar as respostas', 'error')
        }).finally(() => {
          this.sending = false
        })
      }
    }
  },
  created () {
    this.getQuiz()

    // window.addEventListener('beforeunload', (event) => {
    //   event.returnValue = `Você perderá as questões respondidas?`
    // })
  },
  // destroyed () {
  //   window.removeEventListener('beforeunload', () => {})
  // },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  beforeRouteLeave (to, from, next) {
    if (!this.responseSent && this.quiz._id) {
      swalConfirm({
        title: 'Atenção',
        text: 'Você deseja enviar o Quiz apenas com as questões respondidas?',
        btnConfirmText: 'Sim e sair do Quiz',
        btnCancelText: 'Não e Permanecer no Quiz'
      }).then(() => {
        this.sendResponse()
        clearInterval(this.interval)
        next()
      })
    } else {
      // window.removeEventListener('beforeunload', () => null)
      // this.sendResponse()
      clearInterval(this.interval)
      next()
    }
  },

}
</script>
